import { Injectable, isDevMode } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { isValid, getTokenBody } from './auth.helpers';
import { BasketTools } from '@service/basket.tools';
import { CommonService } from '@service/common.service';
import { clearStorage, getParseToken } from '@core/_utils/tools.utils';
import { filter } from 'rxjs';
import { RequestTools } from '@service/request.tools';
import { CheckTools } from '@service/check.tools';


@Injectable()
export class AuthService {
    public userName = '';
    public clientName = '';
    private events$;
    public currentRoute = '';
    public allowRoute: boolean = false;

    constructor(private router: Router, private basketTools: BasketTools, private commonService: CommonService,
        private requestTools: RequestTools, private checkTools: CheckTools
        ) {
            this.events$ = this.router.events.pipe(filter(event => event instanceof NavigationStart))
            .subscribe(params => {
                this.currentRoute = params['url'];
            });
        }

    public isAuthenticated(): Promise<boolean> {
        const token = getParseToken();
        try {
            if (!token) {
                this.clearStorage();
                return new Promise<boolean>((resolve) => { resolve(false);});
            }
            if (isValid(token.token)) { 
                return new Promise<boolean>((resolve) => { resolve(true);});
            } else {
                return new Promise<boolean>((resolve) => { resolve(false);});
            }    
        } catch (e) {
            console.log(e)
        }
        return new Promise<boolean>((resolve) => { resolve(false);});
    }

    public async checkUrl() {
        let wRes: any;
        if (this.currentRoute === '/'){
            return true;
        }
        const wParams = { Page: this.currentRoute };
        wRes = await this.requestTools.execUrlAction('getaccess', wParams);
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            return false;
        }
        return wRes['data']['data'];
    }

    public hasToken() {
        const token = getParseToken();

        return token !== null && token !== undefined && token !== 'null';
    }

    public async logout() {
        await this.commonService.unlockDoc();
        this.basketTools.clear();
        this.router.navigate(['login']);
    }

    public goDash() {
        if (this.commonService.resetPass === false) {
            this.router.navigate(['dashboard']);
        } else {
            this.router.navigate(['page-reset-pwd']);
        }
    }

    public getToken() {
        const token = getParseToken();
        if (token) {
            return token.token;
        } else {
            this.clearStorage();
        }
    }

    public getApi() {
        const token = getParseToken();
        if (token) {
            return getTokenBody(token.token).api;
        } else {
            this.clearStorage();
        }
    }

    public getUser() {
        const token = getParseToken();
        if (token) {
            return getTokenBody(token.token).user;
        } else {
            this.clearStorage();
        }
    }

    public getUserFirstLastName() {
        if (this.isAdmin()) {
            return 'Administrateur';
        }
        const token = getParseToken();
        if (token) {
            return token.username;
        } else {
            this.clearStorage();
        }
    }

    public isAdmin() {
        const token = getParseToken();
        if (token) {
            return getTokenBody(token.token).role;
        } else {
            this.clearStorage();
        }
    }

    public isAutoGenerated() {
        const token = getParseToken();
        if (token) {
            return getTokenBody(token.token).autogenerated;
        } else {
            this.clearStorage();
        }
    }

    public clearStorage() {
        clearStorage();
        this.basketTools.clear();
    }

    public ngOnDestroy() {
        this.events$.unsubscribe();
    }
}
